import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import adminManufacturersApi from "./api/adminManufacturersApi";
import adminCategoriesApi from "./api/adminCategoriesApi";
import adminRfqsApi from "./api/adminRfqsApi";
import { AdminRfqQueryParameter, AdminRfqsQuery, AdminRfqsState } from "./models/AdminRfqsModels";

export const getAdminRfqs = createAsyncThunk(
  "adminRfqs/getAdminRfqs",
  async (query: AdminRfqsQuery) => {
    return adminRfqsApi.getAdminRfqs(query);
  }
);

export const getAdminRfq = createAsyncThunk(
  "adminRfqs/getAdminRfq",
  async (id: string) => {
    return adminRfqsApi.getAdminRfq(id);
  }
);

export const deleteAdminRfq = createAsyncThunk(
  "adminRfqs/deleteAdminRfq",
  async (id: string) => {
    return adminRfqsApi.deleteAdminRfq(id);
  }
);

export const getManufacturers = createAsyncThunk(
  "adminRfqs/getManufacturers",
  async () => {
    return adminManufacturersApi.getManufacturers();
  }
);

export const getCategories = createAsyncThunk(
  "adminRfqs/getCategories",
  async () => {
    return adminCategoriesApi.getCategories();
  }
);

const initialState: AdminRfqsState = {
  query: {
    search: undefined,
    sortBy: AdminRfqQueryParameter.createdDate,
    sortDesc: true,
    pageNo: 1,
    pageSize: 20
  },
  rfqs: undefined,
  rfq: undefined,
  manufacturers: [],
  categories: [],
  loading: false,
  success: undefined,
  error: undefined,
};

const adminRfqsSlice = createSlice({
  name: "adminRfqs",
  initialState: initialState,
  reducers: {
    changeQuery: (state, { payload }) => {
      state.query = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getAdminRfqs.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAdminRfqs.fulfilled, (state, { payload }) => {
        state.rfqs = payload;
        state.loading = false;
      })
      .addCase(getAdminRfqs.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getAdminRfq.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAdminRfq.fulfilled, (state, { payload }) => {
        state.rfq = payload;
        state.loading = false;
      })
      .addCase(getAdminRfq.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(deleteAdminRfq.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAdminRfq.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(deleteAdminRfq.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getManufacturers.fulfilled, (state, { payload }) => {
        state.manufacturers = payload;
        state.loading = false;
      })

    builder
      .addCase(getCategories.fulfilled, (state, { payload }) => {
        state.categories = payload;
        state.loading = false;
      })
  }
});

export const {
  changeQuery,
  setLoading,
  setSuccess,
  setError
} = adminRfqsSlice.actions;

export default adminRfqsSlice.reducer;